import React, { useCallback } from 'react';

import { Checkbox } from '@vtblife/uikit';
import { NewBuilding } from '@search/filter-enums/enums/NewBuilding';
import classname from '@search/classname/src';

import { NewBuildingFilter } from '../../../../models/Filter';
import { CheckboxGroup2 } from '../../../common/CheckboxGroup2';

import './MobileNewBuildingFilterView.css';

const cn = classname.bind(null, 'MobileNewBuildingFilterView');

interface IMobileNewBuildingFilterViewProps {
    filter: NewBuildingFilter;
    handleChange: (filter: NewBuildingFilter) => void;
    classNameGroup?: string;
}

const selectOptions = [ {
    value: NewBuilding.UNKNOWN,
    label: 'Все',
}, {
    value: NewBuilding.SECOND,
    label: 'Вторичка'
}, {
    value: NewBuilding.NEW,
    label: 'Новостройка'
} ];

export const MobileNewBuildingFilterView: React.FC<IMobileNewBuildingFilterViewProps> = ({
    filter,
    handleChange,
    classNameGroup
}) => {
    const onChange = useCallback((values: NewBuilding) => {
        handleChange(new NewBuildingFilter([ values ].map(item => Number(item)).filter(value => value !== NewBuilding.UNKNOWN)));
    }, [ handleChange ]);

    return (
        <CheckboxGroup2
            mode='radio'
            onChange={onChange}
            name='newBuilding'
            value={filter.newBuilding.length === 0 ? [ String(NewBuilding.UNKNOWN) ] : filter.newBuilding.map(item => String(item))}
            classNameGroup={classNameGroup}
            withoutGrid
            isFilter
        >
            {selectOptions.map(({ value, label }) => (
                <Checkbox
                    key={value}
                    variant='filter'
                    name={String(value)}
                    block
                >
                    {label}
                </Checkbox>
            ))}
        </CheckboxGroup2>
    );
};
